﻿export class LegalEntityOverviewModel {
    legalEntityId: string;
    legalEntityCode: string;
    legalEntityName: string;
    jurisdiction: string;
    legalEntityForm: string;
    salesType: string;
    jurisdictionId: string;
}